import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}",{ moduleName: "bullitt-time-live/templates/event/class-group/class.hbs" })